import type { Kpi } from '@interfaces/IKpi';
import { MockPill } from '@components/ui/MockPill/MockPill';
import styles from './styles.module.css';

type IKpiTileProps = { k: Kpi };

export function KpiTile({ k }: IKpiTileProps) {
  const isMock = k.source === 'daitec' || k.source === 'visual';
  return (
    <article
      className={styles.tile}
      data-direction={k.direction}
      data-testid="kpi-tile"
    >
      <div className={styles.label}>
        {k.label}
        {isMock && <MockPill kind="badge" />}
      </div>
      <div className={styles.valueRow}>
        <span className={styles.value}>{k.value}</span>
        {k.unit ? <span className={styles.unit}>{k.unit}</span> : null}
      </div>
      {k.subline ? (
        <div className={styles.subline} data-testid="kpi-subline">{k.subline}</div>
      ) : (
        <div className={styles.delta}>{k.delta}</div>
      )}
    </article>
  );
}
